'use client'

import { Text } from '@/components/ui/typography/text'
import { useTrack } from '@/hooks/useTrack'
import { SignOutButton, SignedIn, SignedOut, UserButton } from '@clerk/nextjs'
import { Avatar, Burger, Drawer, ScrollArea, Stack } from '@mantine/core'
import isMobile from 'is-mobile'
import Link from 'next/link'
import { parseAsBoolean, useQueryState } from 'nuqs'
import { menuSections, userSections } from '../_helpers/menuSections'
import { ArrowSvg } from '../onboarding/svg/ArrowSvg'

export function BurgerMenu() {
	const [menu, setMenu] = useQueryState('menu', parseAsBoolean.withDefault(false))
	const { track } = useTrack()
	const clerkMenu = isMobile() ? (
		<UserButton
			showName={false}
			fallback={<Avatar size="lg" className="border-2 border-wine" />}
			appearance={{
				elements: {
					avatarBox: 'w-12 h-12 border-2 border-wine rounded-full',
				},
			}}
		/>
	) : (
		<></>
	)

	return (
		<>
			<Burger
				aria-label="Burger Menu Button"
				color="#814256"
				size={25}
				opened={menu}
				onClick={() => {
					track('burger_menu_clicked', {
						menu: menu ? 'open' : 'closed',
					})
					setMenu(!menu)
				}}
			/>
			<Drawer opened={menu} onClose={() => setMenu(false)} size={350} withCloseButton={false}>
				<ScrollArea>
					<Stack gap="lg" p="md">
						{/* Back arrow */}
						<div
							onClick={() => {
								track('burger_menu_back_arrow_clicked', {
									menu: menu ? 'open' : 'closed',
								})
								setMenu(false)
							}}
							className="w-[25px] cursor-pointer"
						>
							<ArrowSvg className="fill-wine -rotate-90 " />
						</div>

						{/* Clerk Menu with styled box */}
						{clerkMenu && <div className=" p-3 flex items-center justify-center shadow-sm">{clerkMenu}</div>}

						{/* Menu items */}
						<Stack gap="md" mt="sm">
							<SignedOut>
								{Object.values(menuSections()).map(({ id, href, name }) => (
									<Link
										key={id}
										href={href}
										onClick={() => {
											track(`burger_menu_item_${name.toLowerCase()}_clicked`)
											setTimeout(() => setMenu(false), 1000)
										}}
									>
										<Text className="flex items-center text-wine gap-2 text-2xl cursor-pointer">{name.toLowerCase()}</Text>
									</Link>
								))}
							</SignedOut>
							<SignedIn>
								{Object.values(userSections()).map(({ id, href, name }) => (
									<Link
										key={id}
										href={href}
										onClick={() => {
											track(`burger_menu_item_${name.toLowerCase()}_clicked`)
											setTimeout(() => setMenu(false), 1000)
										}}
									>
										<Text className="flex items-center text-wine gap-2 text-2xl cursor-pointer">{name.toLowerCase()}</Text>
									</Link>
								))}
								<SignOutButton>
									<Text
										onClick={() => {
											track('burger_menu_sign_out_clicked')
											setTimeout(() => setMenu(false), 500)
										}}
										className="flex items-center text-wine gap-2 text-2xl cursor-pointer "
									>
										sair
									</Text>
								</SignOutButton>
							</SignedIn>
						</Stack>
					</Stack>
				</ScrollArea>
			</Drawer>
		</>
	)
}
